import { render, staticRenderFns } from "./TapeManagementGeneralInformation.vue?vue&type=template&id=35618e47&"
import script from "./TapeManagementGeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./TapeManagementGeneralInformation.vue?vue&type=script&lang=ts&"
import style0 from "./TapeManagementGeneralInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VForm,VRow,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35618e47')) {
      api.createRecord('35618e47', component.options)
    } else {
      api.reload('35618e47', component.options)
    }
    module.hot.accept("./TapeManagementGeneralInformation.vue?vue&type=template&id=35618e47&", function () {
      api.rerender('35618e47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/tape-management/TapeManagementGeneralInformation.vue"
export default component.exports